import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
  BasePageMetaResolver,
  ProductSearchService,
  RoutingService,
  SearchPageMetaResolver,
  TranslationService,
} from '@spartacus/core';
import {switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DCPSearchPageMetaResolver extends SearchPageMetaResolver {
  constructor(
    routingService: RoutingService,
    productSearchService: ProductSearchService,
    translation: TranslationService,
    basePageMetaResolver: BasePageMetaResolver
  ) {
    super(routingService, productSearchService, translation, basePageMetaResolver);
  }

  /**
   * Method that returns titles for search result page
   * depends on total count of found products and search query
   */
  resolveTitle(): Observable<string> {
    return this.productSearchService.getResults().pipe(
      switchMap((productSearchPage) => {
        const total: number = productSearchPage?.pagination?.totalResults;
        const query: string = productSearchPage?.freeTextSearch;
        if (total && query) {
          return this.translation.translate('pageMetaResolver.resultsFor', {
            count: total,
          });
        } else if (total) {
          return this.translation.translate('pageMetaResolver.facetResult', {
            count: total,
          });
        } else {
          return this.translation.translate('pageMetaResolver.noProductsFound');
        }
      })
    );
  }
}
